import React, { useState } from 'react';
import { HomeDesignA } from './HomeDesignA';
import { HomeDesignB } from './HomeDesignB';
import { HomeDesignC } from './HomeDesignC';
import { Layout, Columns, Grid } from 'lucide-react';
type HomeDesignTesterProps = {
  onNavigate?: (page: string) => void;
  onViewStory?: (storyId: number) => void;
  onStartStorybookCreation?: (storyId: number) => void;
  onStartRecording?: () => void;
};
export function HomeDesignTester({
  onNavigate,
  onViewStory,
  onStartStorybookCreation,
  onStartRecording
}: HomeDesignTesterProps) {
  const [activeDesign, setActiveDesign] = useState<'A' | 'B' | 'C'>('A');
  const designs = [{
    id: 'A' as const,
    name: 'Original Design',
    description: 'Large hero CTA, smart suggestions, activity feed',
    icon: Layout,
    color: 'green'
  }, {
    id: 'B' as const,
    name: 'Variant 1',
    description: 'Split hero layout, horizontal suggestions, 3-column stats',
    icon: Columns,
    color: 'blue'
  }, {
    id: 'C' as const,
    name: 'Variant 2',
    description: 'Compact hero, image-based suggestions, goal rewards',
    icon: Grid,
    color: 'purple'
  }];
  return <div className="flex-1 bg-gray-100 min-h-screen" data-id="element-1046">
      {/* Design Selector */}
      <div className="bg-white border-b border-gray-200 px-8 py-4 sticky top-0 z-10 shadow-sm" data-id="element-1047">
        <div className="flex items-center justify-between mb-4" data-id="element-1048">
          <div data-id="element-1049">
            <h1 className="text-2xl font-bold text-gray-900 mb-1" data-id="element-1050">
              Home Page Design Tester
            </h1>
            <p className="text-sm text-gray-600" data-id="element-1051">
              Compare different home page designs
            </p>
          </div>
        </div>

        <div className="flex gap-3" data-id="element-1052">
          {designs.map(design => {
          const Icon = design.icon;
          const isActive = activeDesign === design.id;
          return <button key={design.id} onClick={() => setActiveDesign(design.id)} className={`flex items-center gap-3 px-6 py-3 rounded-xl transition-all ${isActive ? `bg-${design.color}-500 text-white shadow-lg` : 'bg-gray-100 text-gray-700 hover:bg-gray-200'}`} data-id="element-1053">
                <Icon className="w-5 h-5" data-id="element-1054" />
                <div className="text-left" data-id="element-1055">
                  <div className="font-semibold" data-id="element-1056">Design {design.id}</div>
                  <div className={`text-xs ${isActive ? 'text-white/80' : 'text-gray-500'}`} data-id="element-1057">
                    {design.name}
                  </div>
                </div>
              </button>;
        })}
        </div>
      </div>

      {/* Design Description */}
      <div className="bg-gradient-to-r from-gray-50 to-gray-100 px-8 py-4 border-b border-gray-200" data-id="element-1058">
        <div className="flex items-center gap-3" data-id="element-1059">
          <div className={`w-10 h-10 rounded-xl flex items-center justify-center bg-${designs.find(d => d.id === activeDesign)?.color}-100`} data-id="element-1060">
            {(() => {
            const Icon = designs.find(d => d.id === activeDesign)?.icon;
            return Icon ? <Icon className={`w-5 h-5 text-${designs.find(d => d.id === activeDesign)?.color}-600`} data-id="element-1061" /> : null;
          })()}
          </div>
          <div data-id="element-1062">
            <h2 className="font-semibold text-gray-900" data-id="element-1063">
              {designs.find(d => d.id === activeDesign)?.name}
            </h2>
            <p className="text-sm text-gray-600" data-id="element-1064">
              {designs.find(d => d.id === activeDesign)?.description}
            </p>
          </div>
        </div>
      </div>

      {/* Render Active Design */}
      <div className="bg-gray-100" data-id="element-1065">
        {activeDesign === 'A' && <HomeDesignA onNavigate={onNavigate} onViewStory={onViewStory} data-id="element-1066" />}
        {activeDesign === 'B' && <HomeDesignB onNavigate={onNavigate} onViewStory={onViewStory} data-id="element-1067" />}
        {activeDesign === 'C' && <HomeDesignC onNavigate={onNavigate} onViewStory={onViewStory} data-id="element-1068" />}
      </div>
    </div>;
}